import ContactsLargeContactInput from "../Inputs/ContactsLargeContactInput";
import { useState } from "react";
import type { AddContactContactType } from "@/Shared/Types/contactTypes";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import {
  EmailRequired,
  contactsErrorMessagesForContact,
} from "../Validators/contactsErrorMessagesForContact";

interface AddContactPageProps {
  contact: AddContactContactType;
  contactChanged: (_: AddContactContactType) => void;
  onDone: () => void;
  onPrevious: () => void;
}
function ContactsAddContactPage(props: AddContactPageProps) {
  const { contact, contactChanged, onPrevious, onDone } = props;
  const [forceValidation, setForceValidation] = useState(false);
  const errorMessages = contactsErrorMessagesForContact(
    contact,
    EmailRequired.EmailNotRequired,
  );

  function isValid() {
    if (
      errorMessages.contactName ||
      errorMessages.emailAddress ||
      errorMessages.phoneNumber
    ) {
      return false;
    } else {
      return true;
    }
  }

  async function onNext() {
    if (!isValid()) {
      setForceValidation(true);
      return;
    }

    onDone();
  }

  return (
    <Stack gap={8}>
      <ContactsLargeContactInput
        contact={contact}
        contactChanged={contactChanged}
        forceValidation={forceValidation}
        errorMessages={errorMessages}
      ></ContactsLargeContactInput>
      <Row justify="between">
        <Button onClick={onPrevious}>Previous</Button>
        <Button primary onClick={onNext}>
          Next
        </Button>
      </Row>
    </Stack>
  );
}
export default ContactsAddContactPage;
